/*
 * Wires the Archive terminals (1970s/80s/90s/2000s) to the real Shopify catalog,
 * replacing the four small fixed demo dictionaries the base app shipped with
 * (SATComponent's own records70/records80/records90/records00 instance fields).
 * One product, tagged with the right custom.era value, now appears on the
 * Manifest, The Southern Air Import, AND its matching Archive terminal — no
 * separate listing anywhere.
 *
 * How a product lands on a terminal: set its custom.era metafield to a value
 * containing "1970"/"70s", "1980"/"80s", "1990"/"90s" or "2000"/"00s" (the
 * Manifest and Import already read this same field, so this is nothing new to
 * fill in — see Theme settings → Stock). A product not tagged with a decade
 * simply doesn't appear on any terminal; it's still on the Manifest and Import.
 *
 * This works by REPLACING the source data (this.records70 etc.) rather than
 * overriding renderVals' output fields (list70Items, rec70, ...), because the
 * base app's own navigation methods (openArchive80, open70, noteSeenRecord, the
 * "recently viewed" tracker) read this.records80[id] etc. directly — patching
 * only the rendered output would leave those methods still looking at the old
 * demo data. Records are keyed by the product's own stock code (the same id
 * used everywhere else in the app), formatted as "SAT-<code>" — which is
 * exactly the format assets/sat-terminal-buy-patch.js already expects when it
 * matches a record's code back to a real product to wire Buy Now / Add To
 * Crate, so that patch needs no changes and just works against this data.
 *
 * Runs first in the renderVals chain (before calling the original) so the base
 * method's own computation of list70Items/rec70/etc. — which happens inside
 * that original call — already sees the real catalog.
 *
 * Every step here is wrapped defensively: sat-runtime.js's own render loop
 * treats any error thrown out of renderVals() as fatal for that render pass
 * (it logs the error and skips updating the DOM entirely — see mount() in
 * assets/sat-runtime.js), so a bug in this file, if left unguarded, would not
 * just break the terminals, it would freeze or blank the WHOLE app on
 * whichever render happened to hit it. Anything unexpected here is swallowed
 * and falls back to leaving records70/80/90/00 exactly as the previous
 * successful pass left them, rather than risking that.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var DECADE_TOKENS = {
    '1970s': ['1970', '70s'],
    '1980s': ['1980', '80s'],
    '1990s': ['1990', '90s'],
    '2000s': ['2000', '00s']
  };

  function matchesDecade(era, decade) {
    var e = String(era || '').toLowerCase();
    return DECADE_TOKENS[decade].some(function (tok) { return e.indexOf(tok) !== -1; });
  }

  function stockLine(p) {
    var n = Number(p.stock);
    if (!(n > 0)) return 'SOLD OUT';
    if (n > 5) return 'IN STOCK';
    return 'ONLY ' + n + ' ON FILE';
  }

  function buildRecords(products, decade, reelPrefix) {
    var out = {};
    products
      .filter(function (p) { return p && matchesDecade(p.era, decade); })
      .forEach(function (p, i) {
        if (!p.id) return; // no stock code, nothing stable to key or buy against
        var rec = {
          code: 'SAT-' + p.id,
          name: p.name || 'Untitled',
          price: '$' + (p.price != null ? p.price : ''),
          desc: p.detail || p.blurb || '',
          photo: p.photo || '',
          stats: [
            ['CONDITION', p.cond || 'UNKNOWN'],
            ['DEPARTMENT', p.cat || 'FIELD GEAR'],
            ['ON FILE', stockLine(p)],
            ['ERA', p.era || decade]
          ]
        };
        if (reelPrefix) rec.reel = reelPrefix + ' ' + String(i + 1).padStart(2, '0');
        out[p.id] = rec;
      });
    return out;
  }

  function safeBuild(products, decade, reelPrefix, fallback) {
    try {
      return buildRecords(products, decade, reelPrefix);
    } catch (e) {
      console.error('[sat-era-catalog-patch] failed building ' + decade + ' records, keeping previous:', e);
      return fallback;
    }
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    try {
      var products = Array.isArray(this._products) ? this._products : [];
      this.records70 = safeBuild(products, '1970s', 'BRIEFING REEL', this.records70);
      this.records80 = safeBuild(products, '1980s', null, this.records80);
      this.records90 = safeBuild(products, '1990s', null, this.records90);
      this.records00 = safeBuild(products, '2000s', null, this.records00);
    } catch (e) {
      console.error('[sat-era-catalog-patch] unexpected error, leaving records untouched:', e);
    }
    return orig.call(this);
  };
})();
